// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmModal-container-1e79"};